import { RichText } from "@vinomofo/gatsby-types";
import { TextBlock } from "../components/text-block";
import { richTextRenderer } from "../utils/rich-text-renderer";

const test = ({ __typename }: { __typename: string }): boolean =>
  __typename === "VinoData_TextBlock";

const create = (data: {
  textAlign: string;
  title: string;
  textBody: RichText;
}): JSX.Element => {
  const { textBody, textAlign, title } = data;
  const bodyTextJson = { json: JSON.parse(textBody.json.raw) };

  return (
    <TextBlock
      textAlign={textAlign}
      header={title}
      bodyText={richTextRenderer(bodyTextJson, { p: { fontSize: [1, 2] } })}
    />
  );
};

export default { test, create };
